import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'
import { useCarouselAutoScroll } from './use-carousel-auto-scroll'
import { useCarouselNavigation } from './use-carousel-navigation'

export default class CarouselController extends Controller {
  static targets = ['list', 'navigation']

  connect () {
    if (this.startInteraction) {
      this.sliders.forEach(slider => useIntersection(this, { element: slider, threshold: 0.8 }))
      useCarouselNavigation(this, this.navigationTarget, this.sliders)
      useCarouselAutoScroll(this, this.dots, this.sliders)

      document.addEventListener('touchstart', this.pause, false)
    }
  }

  appear (entry) {
    this.intersected(entry.target)
  }

  get startInteraction () {
    return this.sliders.length > 1
  }

  get sliders () {
    return Array.from(this.listTarget.children)
  }
}
